import React from 'react'
import { useSelector } from 'react-redux'
import { usePathParam } from '@chilecompra/react-kit'
import { PATH_PARAM } from '../../config/settings/regexes'
import routes from '../../config/settings/routes'
import { CertificateLink, Column, Image } from './EnrollmentCertificateButton.styles'
import { sendAnalyticsEvent } from '../../config/settings/analytics'

/**
 * The Enrollment Certificate Button' container.
 */
const EnrollmentCertificateButton = () => {
  const dni = usePathParam('rut')
  const { error, loading } = useSelector(state => state.basicSellerInformation)
  const { error: summaryError } = useSelector(state => state.summarySection)
  const handleClick = () => {
    sendAnalyticsEvent({
      action: `Click generar certificado`,
      category: 'click-boton-certificado',
      label: 'genera-certificado'
    })
  }

  return loading || error || summaryError?.reason === 'FORBIDDEN_ERROR' ? null : (
    <Column margin="1.5rem 0 0.5rem 0" padding="0">
      <CertificateLink
        color="primary"
        target="_blank"
        to={routes.enrollmentCertificateBySeller.replace(PATH_PARAM, dni)}
        variant="outlined"
        width="100%"
        onClick={handleClick}
      >
        <Image alt="" />
        Generar certificado de habilidad
      </CertificateLink>
    </Column>
  )
}

export default EnrollmentCertificateButton
